import $ from 'jquery';
import { getInputValue } from '../utils/input';
const ELEMENT_SELECTOR = '.js__keep-input-value';
export class KeepInputValue {
    static valuesToRemoveOnPageChange = sessionStorage.getItem('valuesToRemoveOnPageChange')
        ? sessionStorage.getItem('valuesToRemoveOnPageChange').split(',')
        : [];
    static init($root = $('body')) {
        const $element = $root.find(ELEMENT_SELECTOR);
        this.removeValues();
        if (!$element.length) {
            return;
        }
        this.saveValueOnChange($element);
        this.setSavedValues($element);
    }
    static saveValueOnChange($element) {
        $element.each((index, element) => {
            const $element = $(element);
            $element
                .find('select, input')
                .addBack()
                .on('change', e => {
                const $input = $(e.currentTarget);
                const removeValueOnPageChange = $input.data('remove-input-value-on-page-change');
                const value = getInputValue($input);
                const inputName = $input.attr('id') || 'unnamed';
                sessionStorage.setItem(inputName, String(value));
                if (removeValueOnPageChange) {
                    this.valuesToRemoveOnPageChange.push(inputName);
                    sessionStorage.setItem('valuesToRemoveOnPageChange', this.valuesToRemoveOnPageChange.join(','));
                }
            });
        });
    }
    static setSavedValues($element) {
        $element.each((index, element) => {
            const $element = $(element).find('select, input').addBack();
            const savedValue = sessionStorage.getItem($element.attr('id') || 'unnamed') || '';
            if (savedValue) {
                $element.val(savedValue);
            }
        });
    }
    static removeValues() {
        this.valuesToRemoveOnPageChange.forEach(id => {
            const $element = $(`#${id}`);
            if (!$element.length) {
                sessionStorage.removeItem(id);
                sessionStorage.removeItem('valuesToRemoveOnPageChange');
                this.valuesToRemoveOnPageChange = [];
            }
        });
    }
}
